// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1029) return "static/chunks/1029-aa0eba64c9467896.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"272":"4032b898b19fa457","5957":"90815ecb6756f16f","6191":"6c2911d2ae6a767c","8836":"9efa81bc48883609"}[chunkId] + ".js";
};